export default "__VITE_PUBLIC_ASSET__533f41b4__"